import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoshirdicab() {



const cardData = {
  keyword: "Mumbai to Shirdi Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Shirdi cab services for travelers seeking a smooth and convenient journey to one of Maharashtra’s most revered pilgrimage destinations. Whether you are planning a spiritual trip, a family visit, or a group tour, our cab service ensures safe and stress-free travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent and affordable per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers, suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Shirdi cab services.",

topPlaces: [
  {
    title: "Shirdi Sai Baba Temple",
    description:
      "The Shirdi Sai Baba Temple is the most important spiritual destination in Shirdi, attracting millions of devotees every year. The temple complex includes the Samadhi Mandir, where the saint’s mortal remains are enshrined, as well as other structures like Dwarkamai, Chavadi, and the Gurusthan. Visitors can participate in rituals, aarti ceremonies, and charity events, while the serene environment allows for deep spiritual reflection. A comfortable cab ride ensures you reach the temple early to experience the peaceful atmosphere without worrying about transportation or parking, especially during festivals and peak pilgrimage seasons."
  },
  {
    title: "Dwarkamai Mosque",
    description:
      "Dwarkamai Mosque is a historic mosque within the Shirdi Sai Baba complex where Sai Baba spent a significant part of his life. It holds immense religious significance for devotees, who often visit to see the sacred fire (dhuni) that has been burning continuously since Baba’s time. Travelers can explore the mosque, learn about Sai Baba’s teachings, and witness daily rituals. A cab service allows visitors to comfortably manage their time across the temple complex and nearby attractions, making the spiritual journey relaxed and organized."
  },
  {
    title: "Chavadi",
    description:
      "Chavadi is a small building in Shirdi where Sai Baba used to sleep on alternate nights. It is an important site for devotees who wish to connect with the saint’s life and follow his spiritual legacy. The location offers a calm and reflective atmosphere, allowing pilgrims to meditate and learn about Sai Baba’s daily routines. Using a cab ensures travelers can conveniently visit Chavadi along with other nearby temples without rushing or facing transport challenges."
  },
  {
    title: "Gurusthan",
    description:
      "Gurusthan is the sacred site in Shirdi where Sai Baba was first spotted as a young man sitting under a neem tree. It is considered highly significant for devotees, symbolizing the beginning of Sai Baba’s spiritual journey. Visitors often offer prayers, meditate under the neem tree, and reflect on Baba’s teachings. A cab ride makes it easier to include Gurusthan in your itinerary alongside other key locations in Shirdi, providing flexibility and comfort while exploring multiple sites in a single day."
  },
  {
    title: "Sai Heritage Village",
    description:
      "Sai Heritage Village is a cultural and educational attraction in Shirdi that showcases the life, teachings, and miracles of Sai Baba. The complex includes replicas of important sites, informative exhibits, and interactive displays that provide visitors with a deeper understanding of Sai Baba’s legacy. Travelers can enjoy guided tours, watch documentaries, and explore traditional Maharashtrian architecture. Traveling by cab ensures a relaxed visit with enough time to absorb the history and culture without worrying about transportation or schedules."
  },
  {
    title: "Khandoba Temple",
    description:
      "Khandoba Temple in Shirdi is dedicated to Lord Khandoba and is visited by devotees alongside the Sai Baba Temple. The temple features traditional architecture, colorful decorations, and regular religious ceremonies. Pilgrims often combine visits to both temples in a single day. A cab service provides easy access, allowing travelers to manage their time efficiently, avoid long queues, and experience the spiritual and cultural essence of Shirdi with ease."
  },
  {
    title: "Lendi Baug",
    description:
      "Lendi Baug is a beautiful garden in Shirdi where Sai Baba spent time watering plants and meditating. It is a serene place surrounded by lush greenery, fountains, and benches for relaxation. Visitors can take a peaceful stroll, meditate, or enjoy the scenic environment, making it a perfect spot for reflection after visiting the temple. A cab ride ensures convenient travel to Lendi Baug while exploring other nearby attractions without rushing."
  },
  {
    title: "Maruti Mandir",
    description:
      "Maruti Mandir is a temple in Shirdi dedicated to Lord Hanuman, located near the main Sai Baba complex. Devotees visit to seek blessings and witness daily rituals, which are especially vibrant during festivals. Travelers using a cab can easily include this temple in their Shirdi itinerary, ensuring a comfortable and organized trip without worrying about local transportation."
  },
  {
    title: "Shani Shingnapur Temple",
    description:
      "Shani Shingnapur Temple, located about 70 km from Shirdi, is famous for its deity of Shani Dev and the unique village practice of having no doors on houses, symbolizing faith and security. Visitors often make a day trip from Shirdi to this temple to experience its spiritual and cultural significance. A cab service makes it convenient to travel to Shani Shingnapur and return to Shirdi comfortably, allowing a relaxed and fulfilling pilgrimage experience."
  },
  {
    title: "Rahata Ganpati Temple",
    description:
      "Rahata Ganpati Temple is a nearby temple dedicated to Lord Ganesha and is visited by pilgrims traveling to Shirdi. The temple features beautiful architecture, religious ceremonies, and peaceful surroundings. Including this temple in your Shirdi trip via a cab provides a hassle-free way to explore additional spiritual sites in the region, enhancing the overall pilgrimage experience."
  }
],

services: [
{
name: "Mumbai to Shirdi Cab",
description: "Mumbai to Shirdi cab service offers comfortable and reliable transportation for devotees traveling to the famous Sai Baba temple. Our AC sedans, SUVs, and premium vehicles ensure smooth highway journeys. Professional drivers are experienced in long-distance travel and temple routes. Pickup is available from any location in Mumbai including homes, hotels, and airport terminals. Ideal for family pilgrimage trips and weekend darshan travel. Omshree Cab guarantees safe, punctual, and comfortable travel."
},
{
name: "Mumbai to Shirdi Taxi",
description: "Mumbai to Shirdi taxi service provides convenient intercity travel for devotees visiting Sai Baba Temple. Comfortable AC vehicles ensure relaxed long-distance journeys. Experienced drivers ensure safe highway driving and timely arrival for darshan. Flexible pickup options are available from all areas in Mumbai. Perfect for families, senior citizens, and pilgrimage tours."
},
{
name: "Mumbai to Shirdi Cab Service",
description: "Mumbai to Shirdi cab service is designed for passengers seeking comfortable and safe pilgrimage travel. Well-maintained vehicles and trained drivers ensure smooth highway journeys. Pickup is available from homes, hotels, offices, and Mumbai airport. Spacious seating and AC comfort make long-distance travel convenient. Ideal for family and group temple visits."
},
{
name: "Mumbai to Shirdi Taxi Service",
description: "Mumbai to Shirdi taxi service offers dependable road travel for devotees visiting the holy town of Shirdi. Comfortable vehicles and experienced drivers ensure safe travel on highways. AC interiors provide a relaxed travel experience. Flexible booking options allow easy trip planning. Omshree Cab provides reliable taxi services for Shirdi pilgrimage."
},
{
name: "Cab from Mumbai to Shirdi",
description: "Cab from Mumbai to Shirdi provides a convenient private travel option for devotees planning temple visits. Comfortable AC vehicles ensure smooth highway journeys. Professional drivers ensure safe driving and timely arrival. Pickup is available from any location in Mumbai. Ideal for family trips and group pilgrimage travel."
},
{
name: "Taxi from Mumbai to Shirdi",
description: "Taxi from Mumbai to Shirdi offers reliable long-distance transportation for Sai Baba devotees. AC vehicles provide comfortable seating for the entire journey. Experienced drivers ensure safe highway travel and smooth temple visits. Flexible booking options allow easy travel planning. Ideal for families and senior citizens."
},
{
name: "Mumbai to Shirdi Cab Booking",
description: "Mumbai to Shirdi cab booking allows travelers to reserve vehicles easily for temple visits. Instant confirmation and flexible pickup options make travel planning simple. Our fleet includes sedan, SUV, and premium vehicles. Professional drivers ensure safe and comfortable journeys. Perfect for pilgrimage travel."
},
{
name: "Mumbai to Shirdi Taxi Booking Online",
description: "Online taxi booking from Mumbai to Shirdi allows passengers to reserve vehicles instantly from anywhere. Quick booking confirmation ensures reliable travel planning. AC vehicles and experienced drivers provide comfortable highway journeys. Ideal for devotees planning Sai Baba darshan trips."
},
{
name: "Mumbai to Shirdi Cab Price",
description: "Mumbai to Shirdi cab price offers competitive and transparent fare options for devotees traveling to Shirdi. Customers can choose sedan, SUV, or luxury vehicles depending on travel needs. Clear pricing ensures no hidden charges. Comfortable vehicles and experienced drivers ensure safe travel."
},
{
name: "Mumbai to Shirdi Taxi Fare",
description: "Mumbai to Shirdi taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with no hidden costs. AC vehicles ensure comfortable long-distance journeys. Ideal for budget-friendly pilgrimage travel."
},
{
name: "Mumbai to Shirdi One Way Cab",
description: "One way cab from Mumbai to Shirdi is ideal for travelers needing drop service without return charges. This option reduces travel costs while providing comfortable transportation. AC vehicles ensure relaxed highway journeys. Professional drivers ensure safe travel."
},
{
name: "Mumbai to Shirdi Round Trip Taxi",
description: "Round trip taxi from Mumbai to Shirdi provides complete travel convenience for devotees planning return journeys. Flexible return scheduling allows darshan and sightseeing without rush. Vehicles remain available during the entire trip. Ideal for family pilgrimage tours."
},
{
name: "Mumbai Airport to Shirdi Cab",
description: "Mumbai airport to Shirdi cab service offers direct transportation for travelers arriving at the airport. Immediate pickup from airport terminals ensures quick travel to Shirdi. Comfortable AC vehicles and experienced drivers ensure safe highway journeys. Ideal for tourists and pilgrims."
},
{
name: "Mumbai to Shirdi Innova Cab",
description: "Innova cab from Mumbai to Shirdi is perfect for families and group travelers requiring spacious seating and luggage capacity. The premium MPV offers comfortable seating for long-distance journeys. Smooth suspension ensures relaxed travel. Ideal for pilgrimage trips."
},
{
name: "Mumbai to Shirdi Ertiga Cab",
description: "Ertiga cab from Mumbai to Shirdi offers comfortable travel for medium-size families and groups. Spacious interiors ensure relaxed seating for long journeys. AC comfort keeps passengers comfortable throughout the trip. Ideal for budget-friendly pilgrimage travel."
},
{
name: "Mumbai to Shirdi Sedan Cab",
description: "Sedan cab from Mumbai to Shirdi provides economical travel for couples and small families. Vehicles like Swift Dzire and Etios ensure smooth highway journeys. AC interiors provide comfortable long-distance travel. Ideal for affordable temple travel."
}
],

tableData: [
["Mumbai to Shirdi Cab","Mumbai to Shirdi Taxi"],
["Mumbai to Shirdi Cab Service","Mumbai to Shirdi Taxi Service"],
["Cab from Mumbai to Shirdi","Taxi from Mumbai to Shirdi"],
["Mumbai to Shirdi Cab Booking","Mumbai to Shirdi Taxi Booking Online"],
["Mumbai to Shirdi Cab Price","Mumbai to Shirdi Taxi Fare"],
["Mumbai to Shirdi One Way Cab","Mumbai to Shirdi Round Trip Taxi"],
["Mumbai Airport to Shirdi Cab","Mumbai to Shirdi Innova Cab"],
["Mumbai to Shirdi Ertiga Cab","Mumbai to Shirdi Sedan Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our professional drivers are highly experienced with the Mumbai to Shirdi highway route and are familiar with the best roads, traffic patterns, and rest stops along the way. Their knowledge ensures a smooth, safe, and comfortable journey for pilgrims traveling to Shirdi Sai Baba Temple."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and honest pricing for Mumbai to Shirdi cab services. We share the complete fare details in advance, including per-kilometer rates and trip packages, so you never face hidden charges or unexpected costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Pilgrimage trips often start early morning or late at night. Omshree Cabs operates 24/7 to provide convenient travel options from Mumbai to Shirdi whenever you need them. Our team ensures quick confirmation and reliable service."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and sanitized air-conditioned vehicles designed for long-distance travel. Every car is cleaned before each trip so passengers can enjoy a comfortable and hygienic ride from Mumbai to Shirdi."
  },
  {
    WhyChooseheading: "Flexible Travel Packages",
    WhyChoosedescription: "Omshree Cabs offers flexible travel plans including one-way trips, round trips, and same-day Shirdi darshan packages. Whether you are traveling alone, with family, or in a group, we customize the journey to match your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles for comfortable group travel. We ensure the right vehicle for every type of Shirdi pilgrimage trip."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "Our cab service provides convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. The driver arrives on time and starts your journey directly from your location, making travel stress-free."
  },
  {
    WhyChooseheading: "Reliable Pilgrimage Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Shirdi pilgrimage trips. We focus on punctuality, safety, and customer satisfaction to ensure you reach Shirdi comfortably and on time for Sai Baba darshan."
  }
]
};


const faqData = [
  { question: "What is the distance from Mumbai to Shirdi by cab?", answer: "The distance from Mumbai to Shirdi is approximately 240 km and usually takes about 5–6 hours by cab depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Shirdi cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services from Mumbai to Shirdi." },
  { question: "Do you offer same-day Shirdi darshan packages?", answer: "Yes, we offer convenient same-day return packages for Mumbai to Shirdi darshan trips." },
  { question: "Which vehicles are available for Mumbai to Shirdi travel?", answer: "Sedans, SUVs like Ertiga and Innova, and larger vehicles are available depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, Omshree Cabs provides direct pickup from Mumbai Airport for Shirdi trips." },
  { question: "Do drivers know the Shirdi temple area?", answer: "Yes, our drivers are familiar with the Shirdi temple area, parking locations, and nearby facilities to make your visit convenient." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request rest stops during the journey for meals, refreshments, or breaks." },
  { question: "Is advance booking recommended for Shirdi trips?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and festival seasons when Shirdi receives many pilgrims." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, every vehicle is cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patel",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Shirdi darshan trip. The car was clean, the driver was polite, and the journey was very comfortable. Highly reliable cab service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Sharma",
    feedback:
      "Our family trip from Mumbai to Shirdi with Omshree Cabs was excellent. On-time pickup, smooth ride, and transparent pricing made the entire pilgrimage stress-free.",
    rating: 5
  }
];




























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Shirdi Cab",
  "description": "Book Mumbai to Shirdi Cab with Omshree Cab for comfortable and reliable outstation travel. Choose from Innova, Ertiga, and Sedan cabs for one-way or round trips, including Mumbai airport to Shirdi transfers. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Shirdi.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2900"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai to Shirdi Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Shirdi Cab with Omshree Cab for comfortable and reliable outstation travel. Choose from Innova, Ertiga, and Sedan cabs for one-way or round trips, including Mumbai airport to Shirdi transfers. Enjoy affordable rates, easy online booking, and trusted taxi service from Mumbai to Shirdi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdicab;